import {NotificationDto} from "@esa/api";
import {createReducer, on} from "@ngrx/store";
import {NotificationActions} from "../actions";


export const notificationsFeatureKey = 'notifications';

export interface NotificationsState {
  notifications: NotificationDto[];
}

const initialState: NotificationsState = {
  notifications: []
};

export const notificationsReducer = createReducer(
  initialState,
  on(NotificationActions.getNotificationsSuccess, (state, { notifications }) => ({ ...state, notifications }))
);
